module.exports = __webpack_public_path__ + "c95a71437035a381e03cd49d74e35d99.svg";